import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./FormModal.scss";

// Form/detail popup (add, edit, generate…), styled identically to ConfirmDialog
// with left-aligned header, top-right close button, and right-aligned actions.
const FormModal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "xs",
  PaperProps = {},
}) => {
  const combinedPaperProps = {
    ...PaperProps,
    className: `form-modal-paper ${PaperProps?.className || ""}`.trim(),
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={combinedPaperProps}
      aria-labelledby="form-modal-title"
    >
      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="form-modal-close-btn"
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}

      {title && (
        <div className="form-modal-header">
          <h2 id="form-modal-title" className="form-modal-title">
            {title}
          </h2>
        </div>
      )}

      <DialogContent className="form-modal-body">{children}</DialogContent>

      {actions && (
        <DialogActions className="form-modal-actions">
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default FormModal;
